export default {
    debounce(handle, delay) {
        let time = null;
        return function () {
            let self = this,
                arg = arguments;
            clearTimeout(time);
            time = setTimeout(function () {
                handle.apply(self, arg);
            }, delay)
        }
    },

    checkAuth(rule){
        if(rule){
            var nodes = localStorage.getItem('nodes');
            if(nodes){
                nodes = JSON.parse(nodes);
                if(nodes && nodes.includes(rule)){
                    return true;
                }
            }
        }
        return false;
    },

    imgDomain(src, baseURL){
        return (src && (typeof src === 'string')) ? ((src.indexOf('http') != -1 ? '' : baseURL) + src) : '';
    },

    dealImg(imgStr, BASE_URL) {
        var newStr = imgStr.indexOf("http");
        if (newStr == -1) {
            imgStr = BASE_URL + imgStr.replaceAll('\\', '/')
        } else {
            imgStr = imgStr.replaceAll('https', 'http')
            imgStr = imgStr.replaceAll('http', 'https')
        }
        return imgStr
    },

    float2(value){
        return value.toString().replace(/[^\d^\.]+/g, '').replace(/^0+(\d)/, '$1').replace(/^\./, '0.').match(/^\d*(\.?\d{0,2})/g)[0] || '';
    },

    openwin(url){
        const a = document.createElement('a');
        document.body.appendChild(a);
        a.href = url;
        a.target = '_blank';
        a.click();
        document.body.removeChild(a);
    },

}


// WEBPACK FOOTER //
// ./src/utils/index.js